import { ActionsMap, Unprotected } from '@auth-util-lib/auth.model'
import { MenuEntry } from '@shared-util-lib/models/menu-entry.model'

export const removeForbiddenEntries =
    (actions: ActionsMap) => (entries: MenuEntry[]) =>
        entries.filter(
            (entry) => entry.action === Unprotected || !!actions[entry.action]
        )
